import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { UserDto } from "../../core/resource-dto/user";

import {RoleAdapter} from "../form/role-adapter";
import {CompanyAdapter} from "../form/company-adapter";
import {ManageService} from "../manage/manage.service";
import {UserCompanyFormComponent} from "../form/user-company-form.component";
import {CountryAdapter} from "../../core/services/country-adapter";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

declare let jQuery:any;

@Component({
    templateUrl: './company-add.component.html',
    providers: [ CountryAdapter, RoleAdapter, CompanyAdapter ],
    styleUrls: [
        '../../../assets/styles/pages/editor.less',
        '../../../assets/styles/pages/project.less'
    ],
})
export class CompanyAddComponent implements OnInit, AfterViewInit {

    private ngDestroy: Subject<void> = new Subject<void>();

    @ViewChild(UserCompanyFormComponent, { static: true })
    formComponent:UserCompanyFormComponent;

    public country:number = null;
    public user:UserDto.User = null;
    public userCompany:UserDto.Company = new UserDto.Company();

    public user$:Observable<UserDto.User>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private companyAdapter: CompanyAdapter,
        private roleAdapter: RoleAdapter,
        private manageService:ManageService
    ) {
        this.companyAdapter.loadCompanies();
        this.roleAdapter.loadRoles();

        this.user$ = manageService.user$;
        this.user$.pipe(takeUntil(this.ngDestroy)).subscribe((user:UserDto.User) => {
            this.user = user;
        });
    }

    ngOnInit() {}

    ngAfterViewInit() {}

    ngOnDestroy() {
        this.ngDestroy.next();
        this.ngDestroy.complete();
    }

    btnSaveClicked(e:any) {
        this.formComponent.save();
    }

    formSaved(e:any) {
        this.router.navigate(['..'], {relativeTo: this.route});
    }
}
